module.exports = "leave-teamroom-arrow"